import { SourceType, YoutubeTargetType, YoutubeUrlParser, SourceValidator, UrlParser } from "@authory-packages/core";

export const isValidURL = (type: SourceType) => (value: string | null | undefined) => {
    const url = value;

    try {
        if (typeof url !== "string") return false;

        const domain = UrlParser.extractDomain(url);
        const sourceType = SourceValidator.getSourceTypeFromDomain(domain || "");

        if (sourceType === type) {
            SourceValidator.createSlug(url, null, sourceType);
        }

        return true;
    } catch {
        return false;
    }
};

export const isValidType = (type: SourceType) => (value: string | null | undefined) => {
    const url = value;

    try {
        if (typeof url !== "string") return false;

        const domain = UrlParser.extractDomain(url);
        const sourceType = SourceValidator.getSourceTypeFromDomain(domain || "");

        if ((sourceType === SourceType.EntireInternet && type === SourceType.Web) || (sourceType === SourceType.Sitemap && type === SourceType.Web)) {
            return true;
        }

        return sourceType === type;
    } catch {
        return false;
    }
};

export const isYoutubeVideo = (value: string | null | undefined) => {
    if (!value) return true;

    const youtubeParsed = YoutubeUrlParser.parseYoutubeUrl(value);

    if (youtubeParsed?.type !== YoutubeTargetType.Video) return true;
    return false;
};

export enum INVALID_URLS {
    PODCAST = "invalid_podcast_url",
    YOUTUBE = "invalid_youtube_url",
    SOURCE_MISSMATCH = "types_and_url_do_not_match"
}

export const PodcastErrorMessage = () => (
    <span>
        Invalid podcast url{" "}
        <a style={{ color: "inherit" }} target="_blank" href="https://authory.com/help/en/articles/5151471-how-can-i-import-a-podcast">
            Learn more
        </a>
    </span>
);

export const YoutubeErrorMessage = () => (
    <span>
        Please enter the URL of your YouTube profile, channel or playlist.{" "}
        <a style={{ color: "inherit" }} target="_blank" href="https://authory.com/help/en/articles/5607160-how-can-i-import-from-youtube">
            Learn more
        </a>
    </span>
);
